import React from 'react'
import Tooltip from '../Tooltip/Tooltip'

const InputLabelWithHint = ({ label, hint, hintPosition }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <label
        style={{
          textAlign: 'left',
          fontSize: '16px',
          color: '#546b81',
          fontFamily: 'Roboto Regular',
          lineHeight: '24px',
          margin: '0 0 10px 0',
        }}
      >
        {label}
      </label>
      <Tooltip content={hint} hintPosition={hintPosition} />
    </div>
  )
}

export default InputLabelWithHint
